/**
 * Centralized Google Drive stream URL builder.
 * All components that play Drive clips should use this function.
 *
 * Currently proxied through Supabase Edge Function (Cloudflare Workers)
 * to avoid Google's abuse detection on Netlify CDN IPs and CORP: same-site
 * browser restrictions on direct Google URLs.
 *
 * If the proxy ever needs to change, update ONLY this file.
 */

const SUPABASE_URL = 'https://dlmcxxzohervnbixauhs.supabase.co';

export const buildDriveStreamUrl = (fileId) => {
  if (!fileId) return '';
  return `${SUPABASE_URL}/functions/v1/drive-stream-proxy?id=${fileId}`;
};

export default buildDriveStreamUrl;
